import { useFormContext } from "react-hook-form";

import {
  HubButton,
  HubHookFormInput,
  HubHookFormSwitch,
  HubHookFormTimePicker,
  HubIcon,
  StationHookFormSelect,
} from "../../components";
import { StyledCell, StyledStack } from "./styles";

const TableRowSx = {
  justifyItems: "center",
  ".DipRowButton": { display: "none" },
  "&:hover": { ".DipRowButton": { display: "inline" } },
};

const PostFoundryTableRow = ({
  basePath,
  idx = 0,
  remove = () => {},
  getFieldProps = () => ({}),
  handleStationChange = () => {},
  ...rest
}) => {
  const { watch } = useFormContext();

  const row = `${basePath}.${idx}`;
  const cfg = `${row}.config`;

  const isOutside = watch(`${cfg}.isOutside`);

  return (
    <StyledStack sx={TableRowSx} {...rest}>
      <StyledCell direction="row" gap="0px" sx={{ cursor: "grab" }}>
        <HubIcon icon="MoreVertical" size="10px" />
        <HubIcon icon="MoreVertical" size="10px" sx={{ ml: "-7px" }} />
      </StyledCell>
      <StyledCell
        sx={{
          "& .MuiFormControlLabel-root, .MuiFormControl-root": {
            width: "18px",
            gap: "0px",
          },
        }}
      >
        <HubHookFormSwitch
          name={`${cfg}.isOutside`}
          key={`${cfg}.isOutside`}
          shouldUnregister={false}
          isCheckbox
        />
      </StyledCell>
      <StationHookFormSelect
        name={`${row}.stationId`}
        key={`${row}.stationId`}
        department={isOutside ? 6 : 5}
        {...getFieldProps(`${row}.stationId`)}
        onChange={(e) => handleStationChange(row, e.target.value)}
        shouldUnregister={false}
        hideLabel
        required
      />
      <HubHookFormTimePicker
        name={`${row}.leadTime`}
        key={`${row}.leadTime`}
        {...getFieldProps(`${row}.leadTime`)}
        shouldUnregister={false}
        placeholder="124"
        fields={["days"]}
        required
      />
      <HubHookFormTimePicker
        name={`${row}.cycleTime`}
        key={`${row}.cycleTime`}
        {...getFieldProps(`${row}.cycleTime`)}
        fields={["hours", "minutes", "seconds"]}
        shouldUnregister={false}
        placeholder="0.12"
        required
      />
      <HubHookFormInput
        name={`${row}.notes`}
        key={`${row}.notes`}
        {...getFieldProps(`${row}.notes`)}
        shouldUnregister={false}
      />

      <StyledCell>
        <HubButton
          className="DipRowButton"
          icon="Trash2"
          variant="text"
          iconProps={{ size: 14 }}
          sx={{ color: "hubColors.redMain" }}
          onClick={() => remove(idx)}
        />
      </StyledCell>
    </StyledStack>
  );
};

export default PostFoundryTableRow;
